var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2022 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import { useState, useEffect } from "react";
import { withRouter, useHistory } from "react-router-dom";
import { Container, Navbar, Nav, NavDropdown } from 'react-bootstrap';
import { useAuth } from '../contexts/auth.context';
import { getTokenFromLocalStorage, setTokenToLocalStorage, setUserToLocalStorage, tokenHasExpired } from '../services/localStorage/localStorageService';
import Login from './Login';
import { convertToPath } from "../general/Utils";
import { env } from '../variables/config';
import { confirmAuthorised } from '../services/auth/authService';
var assumeProduction = function () {
    console.warn("Error fetching environment. Assuming production.");
    return "production";
};
var fetchEnvironment = function () {
    return fetch(env.API_PATH + '/system/environment')
        .then(function (res) {
        if (res.ok) {
            return res.json();
        }
        return null;
    })
        .then(function (res) {
        if (!(res === null || res === void 0 ? void 0 : res.environment)) {
            return assumeProduction();
        }
        return res.environment;
    })
        .catch(function () {
        return assumeProduction();
    });
};
var getBackgroundClass = function (environment) {
    switch (environment) {
        case "dev":
            return "bg-warning";
        case "testing":
            return "bg-info";
        case "staging":
            return "bg-success";
        case "qa":
            return "bg-secondary";
    }
    return "";
};
function Navigation(props) {
    var _a = useAuth(), token = _a.token, setToken = _a.setToken, user = _a.user, setUser = _a.setUser;
    var history = useHistory();
    var _b = useState(""), environment = _b[0], setEnvironment = _b[1];
    useEffect(function () {
        fetchEnvironment()
            .then(function (fetchedEnvironment) {
            setEnvironment(fetchedEnvironment);
        });
    }, []);
    var isProduction = function () {
        return environment === "production";
    };
    var revokeOicd = function (token) {
        fetch(env.API_PATH + '/auth/logout', {
            body: JSON.stringify({ token: token }),
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
        });
    };
    var logout = function () {
        var token = getTokenFromLocalStorage();
        if (token)
            revokeOicd(token);
        setTokenToLocalStorage('');
        setUserToLocalStorage(null);
        setToken('');
        setUser(null);
        history.replace("/");
    };
    var addPage = function (page) {
        if (!page.hidden) {
            var authorised = confirmAuthorised(user, page.auth);
            if (authorised) {
                return (_jsx(Nav.Link, __assign({ href: convertToPath(page.name) }, { children: page.name }), page.name));
            }
        }
    };
    var addDropdown = function (dropdown) {
        if (!dropdown.hidden) {
            var authorised = confirmAuthorised(user, dropdown.auth);
            if (authorised) {
                return (_jsx(NavDropdown, __assign({ title: dropdown.name }, { children: dropdown.pages && dropdown.pages.map(function (page, index) {
                        return ( // eslint-disable-next-line
                        _jsx("div", __assign({ className: "nav-dropdown-box" }, { children: _jsx(Nav.Link, __assign({ href: convertToPath(dropdown.name)
                                    + convertToPath(page.name) }, { children: page.name }), page.name) }), index));
                    }) })));
            }
        }
    };
    return (_jsx("div", __assign({ className: "navigation" }, { children: _jsx(Navbar, __assign({ className: (isProduction() && environment ?
                "navbar-dark" :
                "navbar-light " + getBackgroundClass(environment))
                + " navbar-custom fixed-top", expand: "lg" }, { children: _jsxs(Container, { children: [_jsxs(Navbar.Brand, __assign({ href: "/" }, { children: [props.brand, environment && !isProduction() &&
                                " " + environment] })), _jsx(Navbar.Toggle, { "aria-controls": "basic-navbar-nav" }), _jsxs(Navbar.Collapse, __assign({ id: "basic-navbar-nav" }, { children: [props.pages.map(function (page, index) {
                                // @ts-ignore
                                if (page.pages !== undefined) {
                                    return (_jsx("span", { children: addDropdown(page) }, index));
                                }
                                else {
                                    return (_jsx("span", { children: addPage(page) }, index));
                                }
                            }), (!token || tokenHasExpired()) && props.login &&
                                _jsx(Nav.Link, __assign({ className: "nav-right" }, { children: _jsx(Login, {}) }), "Login"), token && !tokenHasExpired() && props.login &&
                                _jsx(Nav.Link, __assign({ onClick: logout, className: "nav-right", href: "/" }, { children: "Logout" }), "Logout")] }))] }) })) })));
}
export default withRouter(Navigation);
